window.TLGG_MENU_CONFIG = {
  "crab-rangoon-4": {
    "spice": false,
    "removals": [
      "Sauce on the Side"
    ],
    "extras": []
  },
  "gyoza-4": {
    "spice": false,
    "removals": [
      "Sauce on the Side"
    ],
    "extras": []
  },
  "thai-fried-spring-rolls-2": {
    "spice": false,
    "removals": [
      "Sauce on the Side"
    ],
    "extras": []
  },
  "chicken-sate-4": {
    "spice": false,
    "removals": [
      "Sauce on the Side"
    ],
    "extras": []
  },
  "loco-crunch": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Spicy Mayo",
      "No Avocado",
      "No Cucumber"
    ],
    "extras": []
  },
  "pollo-loco": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Spicy Mayo",
      "No Avocado",
      "No Cucumber"
    ],
    "extras": []
  },
  "slammin-salmon": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Spicy Mayo",
      "No Avocado",
      "No Cucumber"
    ],
    "extras": [
      "Extra Teriyaki Sauce"
    ]
  },
  "okie-pokie-raw": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Spicy Mayo",
      "No Avocado",
      "No Cucumber"
    ],
    "extras": [
      "Extra Loco Sauce",
      "Extra Spicy Mayo"
    ]
  },
  "teriyaki-salmon-poke-bowl": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Spicy Mayo",
      "No Avocado",
      "No Cucumber"
    ],
    "extras": [
      "Extra Salmon (Double Portion)",
      "Extra Teriyaki Sauce",
      "Extra Mango Salsa",
      "Extra Avocado"
    ]
  },
  "spicy-salmon-raw": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Spicy Mayo",
      "No Avocado",
      "No Cucumber"
    ],
    "extras": [
      "Extra Salmon (Double Portion)",
      "Extra Loco Sauce",
      "Extra Mango Salsa",
      "Extra Avocado"
    ]
  },
  "mango-tango-shrimp-grilled": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Spicy Mayo",
      "No Avocado",
      "No Cucumber"
    ],
    "extras": [
      "Extra Shrimp",
      "Extra Mango Salsa",
      "Extra Avocado"
    ]
  },
  "teriyaki-chicken": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Spicy Mayo",
      "No Avocado",
      "No Cucumber"
    ],
    "extras": [
      "Extra Chicken",
      "Extra Mango Salsa",
      "Extra Avocado"
    ]
  },
  "crispy-chicken": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Spicy Mayo",
      "No Avocado",
      "No Cucumber"
    ],
    "extras": [
      "Extra Crispy Chicken",
      "Extra Mango Salsa",
      "Extra Avocado",
      "Extra Sweet Chili Sauce"
    ]
  },
  "shrimp-tempura": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Spicy Mayo",
      "No Avocado",
      "No Cucumber"
    ],
    "extras": [
      "Extra Shrimp Tempura",
      "Extra Mango Salsa",
      "Extra Avocado",
      "Extra Sweet Chili Sauce"
    ]
  },
  "coconut-shrimp": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Spicy Mayo",
      "No Avocado",
      "No Cucumber"
    ],
    "extras": [
      "Extra Coconut Shrimp",
      "Extra Mango Salsa",
      "Extra Avocado",
      "Extra Sweet Chili Sauce"
    ]
  },
  "tofu-bowl": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Spicy Mayo",
      "No Avocado",
      "No Cucumber"
    ],
    "extras": [
      "Extra Tofu",
      "Extra Mango Salsa",
      "Extra Avocado",
      "Extra Sweet Chili Sauce"
    ]
  },
  "sweet-sour-chicken": {
    "spice": false,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Peanuts",
      "No Vegetables"
    ],
    "extras": []
  },
  "curry-of-the-week": {
    "spice": false,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Peanuts",
      "No Vegetables"
    ],
    "extras": []
  },
  "pad-thai": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Peanuts",
      "No Vegetables"
    ],
    "extras": [
      "Extra Chicken",
      "Extra Tofu",
      "Extra Shrimp"
    ]
  },
  "spicy-basil-chicken": {
    "spice": false,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Peanuts",
      "No Vegetables"
    ],
    "extras": [
      "Extra Chicken",
      "Fried Egg"
    ]
  },
  "steamed-chicken-with-spicy-ginger-sauce": {
    "spice": false,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Peanuts",
      "No Vegetables"
    ],
    "extras": [
      "Extra Chicken",
      "Extra Ginger Sauce"
    ]
  },
  "chicken-curry": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Cheese",
      "No Lettuce"
    ],
    "extras": []
  },
  "pgp": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Cheese",
      "No Lettuce"
    ],
    "extras": []
  },
  "orange-power": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Cheese",
      "No Lettuce"
    ],
    "extras": []
  },
  "thai-peanut-chicken-wrap": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Cheese",
      "No Lettuce"
    ],
    "extras": []
  },
  "spy": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Cheese",
      "No Lettuce"
    ],
    "extras": []
  },
  "curry-quesadilla": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Cheese",
      "No Lettuce"
    ],
    "extras": [
      "Extra Curry Sauce",
      "Extra Sour Cream",
      "Extra Pico"
    ]
  },
  "lime-quesadilla": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Cheese",
      "No Lettuce"
    ],
    "extras": [
      "Extra Sour Cream",
      "Extra Pico"
    ]
  },
  "coconut-shrimp-tacos-2": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Cheese",
      "No Lettuce"
    ],
    "extras": []
  },
  "curry-tacos-2": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Cheese",
      "No Lettuce"
    ],
    "extras": []
  },
  "thai-fish-tacos-2": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Cheese",
      "No Lettuce"
    ],
    "extras": []
  },
  "spicy-basil-tacos-2": {
    "spice": true,
    "removals": [
      "No Green Onion",
      "No Cilantro",
      "No Cheese",
      "No Lettuce"
    ],
    "extras": []
  },
  "thai-tea-thai-coffee": {
    "spice": false,
    "removals": [],
    "extras": []
  },
  "jarritos": {
    "spice": false,
    "removals": [],
    "extras": []
  },
  "water-bottle": {
    "spice": false,
    "removals": [],
    "extras": []
  },
  "sodas": {
    "spice": false,
    "removals": [],
    "extras": []
  },
  "green-tea-bottle": {
    "spice": false,
    "removals": [],
    "extras": []
  },
  "gallon-iced-tea": {
    "spice": false,
    "removals": [],
    "extras": []
  },
  "gallon-thai-tea": {
    "spice": false,
    "removals": [],
    "extras": []
  },
  "gallon-lemonade": {
    "spice": false,
    "removals": [],
    "extras": []
  }
};
